export default __webpack_public_path__ + "static/media/kyselyt-taytetyt-lightblue.42a3a8ff.svg";